module.exports = __webpack_public_path__ + "img/cxbg1.9bc83c9.9bc83c9d.jpg";